import { AppSettings } from "@/AppSettings";
import { useMemo } from "react";
import { createEventConfiguration } from "./useEventConfiguration";
import { ConfigurationSourceDataMap, Metadata, Trial } from "@/api/dtos";

const useEventConfigurations = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    trial?: Trial, 
    configurationSourceDataId?: number,
    baseRoute?: string
) => {
    return useMemo(() => {
        if (!metadata || !metadata.events) {
            return undefined;
        }

        return Object.keys(metadata.events).map(studyEventOid => {
            return createEventConfiguration(
                metadata, 
                trialConfiguration?.events, 
                configuration?.events, 
                trial, 
                configuration?.configuration?.isGlobal,
                configuration?.configuration?.id ?? configurationSourceDataId, 
                studyEventOid,
                baseRoute
            );
        }).filter(x => !!x);
    }, [metadata, trialConfiguration?.events, configuration?.events, trial, configurationSourceDataId, baseRoute]) as Array<NonNullable<ReturnType<typeof createEventConfiguration>>> | undefined
};

export default useEventConfigurations;